/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { DateFormatPreferenceEnumType } from "./DateFormatPreferenceEnum"
import { DateTimeFormatEnumType } from "./DateTimeFormatEnum"
import { DistanceUnitEnumType } from "./DistanceUnitEnum"
import { RootStoreType } from "./index"


/**
 * OrganizationSettingsDtoBase
 * auto generated base class for the model OrganizationSettingsDtoModel.
 */
export const OrganizationSettingsDtoModelBase = ModelBase
  .named('OrganizationSettingsDto')
  .props({
    __typename: types.optional(types.literal("OrganizationSettingsDto"), "OrganizationSettingsDto"),
    organizationId: types.union(types.undefined, types.number),
    dateTimeFormat: types.union(types.undefined, DateTimeFormatEnumType),
    distanceUnit: types.union(types.undefined, DistanceUnitEnumType),
    dateFormatPreference: types.union(types.undefined, DateFormatPreferenceEnumType),
    allowDriverOutOfSequence: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class OrganizationSettingsDtoModelSelector extends QueryBuilder {
  get organizationId() { return this.__attr(`organizationId`) }
  get dateTimeFormat() { return this.__attr(`dateTimeFormat`) }
  get distanceUnit() { return this.__attr(`distanceUnit`) }
  get dateFormatPreference() { return this.__attr(`dateFormatPreference`) }
  get allowDriverOutOfSequence() { return this.__attr(`allowDriverOutOfSequence`) }
}
export function selectFromOrganizationSettingsDto() {
  return new OrganizationSettingsDtoModelSelector()
}

export const organizationSettingsDtoModelPrimitives = selectFromOrganizationSettingsDto().organizationId.dateTimeFormat.distanceUnit.dateFormatPreference.allowDriverOutOfSequence
